module.exports = __webpack_public_path__ + "static/img/LACQUERED-PVC-BRISTOL.2eeb899.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/LACQUERED-PVC-BRISTOL.png
// module id = xQlq
// module chunks = 0